// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Statistics_Wrapper__3xdGJ","Filters":"Statistics_Filters__2oohN"};